export const Form = {
  baseStyle: {
    helperText: {
      // set the line height of the helper text to the same as the error text
      lineHeight: 'revert',
    },
  },
}
